import { render } from "./C2cBuy.m.vue?vue&type=template&id=508b448c&scoped=true"
import script from "./C2cBuy.m.vue?vue&type=script&lang=js"
export * from "./C2cBuy.m.vue?vue&type=script&lang=js"

import "./C2cBuy.m.vue?vue&type=style&index=0&id=508b448c&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508b448c"]])

export default __exports__